import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration - using the same project as the mobile app
const firebaseConfig = {
  apiKey: "AIzaSyDE7zHaYvMgrZfg-WjmeQzl02-uA33f3HY",
  authDomain: "nextron-682d1.firebaseapp.com",
  projectId: "nextron-682d1",
  storageBucket: "nextron-682d1.firebasestorage.app",
  messagingSenderId: "424266824172",
  appId: "1:424266824172:web:0bb598ef02b79ededda8c9"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Collection References
export const COLLECTIONS = {
    USERS: 'users',
    PRODUCTS: 'products',
    USER_PRODUCTS: 'userProducts',
    TRANSACTIONS: 'transactions',
    RECHARGE_REQUESTS: 'rechargeRequests',
    WITHDRAWAL_REQUESTS: 'withdrawalRequests',
    BANK_DETAILS: 'bankDetails',
    GIFT_CODES: 'giftCodes',
    ANNOUNCEMENTS: 'announcements',
    PAYMENT_CHANNELS: 'paymentChannels',
};

// Transaction Types
export const TRANSACTION_TYPES = {
    RECHARGE: 'recharge',
    WITHDRAW: 'withdraw',
    PURCHASE: 'purchase',
    DAILY_INCOME: 'daily_income',
    REFERRAL_BONUS: 'referral_bonus',
    GIFT_CODE: 'gift_code',
};

// Status Codes
export const STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
    COMPLETED: 'completed',
};

export default app;
